export const enum CompanyInfoEnum {
  PlanName = 'planName',
  PlanType = 'planType',
  CompanyNumber = 'companyNumber',
  CompanyName = 'companyName',
  Email = 'email',
  Phone = 'phone',
  Name = 'name',
  Address = 'address',
  State = 'state'
}

